module.exports = __webpack_public_path__ + "static/media/cil-user.045ea69a.svg";